import React from 'react';
import { Circle } from 'lucide-react';
import { NAV_ITEMS, ACCOUNT_ITEMS, SYSTEM_STATUS } from '../mock';
import { useApp } from '../context/AppContext';
import Logo from './Logo';

const Sidebar = ({ page, setPage }) => {
  const { wallet } = useApp();
  const renderItem = (item) => {
    const active = page === item.id;
    return (
      <button
        key={item.id}
        onClick={() => setPage(item.id)}
        className={`w-full text-left px-4 py-2.5 flex items-center justify-between text-[13px] tracking-wide transition-colors group ${
          active
            ? 'text-[#22c55e] bg-[#0f1a12] border-l-2 border-[#22c55e]'
            : 'text-[#8a8a8a] hover:text-[#e6e6e6] border-l-2 border-transparent'
        }`}
      >
        <span className="flex items-center gap-2">
          {active && <span className="w-1 h-1 rounded-full bg-[#22c55e] inline-block" />}
          {!active && <span className="w-1 h-1 inline-block" />}
          {item.label}
        </span>
        <span className="text-[10px] tracking-[0.2em] text-[#4a4a4a] font-mono">[{item.code}]</span>
      </button>
    );
  };

  return (
    <aside className="w-[220px] min-w-[220px] border-r border-[#151515] bg-[#080808] flex flex-col h-screen sticky top-0">
      <div className="px-4 pt-5 pb-6 flex items-center">
        <Logo size={20} textSize={13} />
      </div>

      <div className="pb-2">{NAV_ITEMS.map(renderItem)}</div>

      <div className="px-4 pt-6 pb-2 text-[10px] tracking-[0.25em] text-[#4a4a4a]">ACCOUNT</div>
      <div>{ACCOUNT_ITEMS.map(renderItem)}</div>

      <div className="mt-auto px-4 pb-5 pt-4 border-t border-[#151515] text-[10px] tracking-[0.2em]">
        <div className="flex items-center justify-between text-[#5a5a5a] mb-3">
          <span>SYSTEM STATUS</span>
          <span className="flex items-center gap-1.5 text-[#22c55e]">
            <Circle size={7} fill="#22c55e" className="text-[#22c55e]" /> {SYSTEM_STATUS.status}
          </span>
        </div>
        <div className="border border-[#151515] rounded-md p-3">
          <div className="text-[9px] text-[#4a4a4a] mb-1">CREDITS</div>
          <div className="text-[13px] text-[#e6e6e6] font-mono">
            ${Number(wallet.usdt || 0).toFixed(2)} <span className="text-[#4a4a4a]">/</span> ₹{Number(wallet.inr || 0).toFixed(2)}
          </div>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
